import { Typography } from "antd";
import Skeleton from "react-loading-skeleton";

const { Text } = Typography;

interface TextOverrideSkeletonProps {
    enableAnimation: boolean;
    width: number;
    overrideText: string | undefined;
}
export function TextOverrideSkeleton({
    enableAnimation,
    width,
    overrideText,
}: TextOverrideSkeletonProps) {
    return overrideText ? (
        <Text type="secondary">{overrideText}</Text>
    ) : (
        <Skeleton enableAnimation={enableAnimation} width={width} />
    );
}
